import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import {  Typography } from "@material-ui/core";
import Box from '@mui/material/Box';
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import BackgroundTheme from "../../../Common/P2P/Header/BackgroundTheme";
import KycDocumentForm from "./KycDocumentForm";
import KycInfoForm from "./KycInfoForm";
import WebCam from "./WebCam";
import { getManualKycReq,getManualKycImage,getManualKycImageReset } from "./manualKycActions";
const ManualKycLink = () => {
  const dispatch = useDispatch();
  const {personalInfoValue} = useSelector(
    (state: any) => state.personalInfo
  );
  const {manualKycImage,manualKycData,manualKycError} = useSelector(
    (state: any) => state.manualKyc
  );
  const history = useHistory();
  const [disable, setDisable] = useState(true);
  const [showWebCam, setShowWebcam] = useState(false);
  const [kycDocument, setKycDocument] = useState(false);

  useEffect(()=> {
    if(manualKycData || manualKycError){
      if(manualKycData && manualKycData?.status){
        // history.push("/p2p/infoConfirmP2p");
      }
    }
  },[manualKycData,manualKycError])

  const webcamRef = useRef<any>(null);
  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    dispatch(getManualKycImage(imageSrc))
    setShowWebcam(false);
    setDisable(false);
  }, [webcamRef]);

  const handleRetake = () => {
    dispatch(getManualKycImageReset())
    setKycDocument(false);
    setShowWebcam(true);
  };

  const initialValues = {
    pancardNo: personalInfoValue?.panNumber,
  };

  const validationSchema = () =>
    Yup.object().shape({
      pancardNo: Yup.string().required("*Required"),
    });

  const onSubmitHandle = (value: any) => {
    dispatch(getManualKycReq(value))
  };

  const onChangeField = () => {};

  const handleContinue = () => {
    setKycDocument(true);
  };

  const handleImageClick = () => {
    setShowWebcam(true);
  };
  return (
    <>
      <BackgroundTheme>
        <Box className="kycInfo">
          <Typography style={{ marginBottom: "18px" }}>
            <strong>live KYC</strong>
          </Typography>
          <Typography className="fs-14" style={{ marginBottom: "14px" }}>
            This live KYC requires your original{" "}
            <span className="fw-700">PAN card</span> photo.
          </Typography>
          <Typography className="fs-12">
            Keep it handy and proceed forward.
          </Typography>
          {kycDocument ? (
            <KycDocumentForm
            manualKycImage={manualKycImage}
              handleRetake={handleRetake}
              initialValues={initialValues}
              onSubmitHandle={onSubmitHandle}
              validationSchema={validationSchema}
              onChangeField={onChangeField}
              manualKycError={manualKycError}
            />
          ) : (
            <>
              {showWebCam ? (
                <WebCam 
                capture={capture} 
                webcamRef={webcamRef} 
                />
              ) : (
                <KycInfoForm
                manualKycImage={manualKycImage}
                  handleContinue={handleContinue}
                  disable={disable}
                  handleImageClick={handleImageClick}
                />
              )}
            </>
          )}
        </Box>
      </BackgroundTheme>
    </>
  );
};

export default ManualKycLink;